import { __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { KpkFilterModifierType } from '@keepeek/commons';
import { TextField } from '@mui/material';
import clsx from 'clsx';
import StyledFilterText, { classes } from './index.styled.js';

var FilterText = function (_a) {
    var filter = _a.filter, className = _a.className, onFilterUpdate = _a.onFilterUpdate, expandIcon = _a.expandIcon, expanded = _a.expanded, setExpanded = _a.setExpanded, id = _a.id, sx = _a.sx;
    var initialValue = filter.values && filter.values.length > 0 ? filter.values[0].id : "";
    var _b = useState(initialValue), value = _b[0], setValue = _b[1];
    // Need to use useEffect here to change state if derived prop state change :
    // https://reacthustle.com/blog/how-to-update-state-when-props-change-in-react
    useEffect(function () { return setValue(initialValue); }, [initialValue]);
    function handleUpdate() {
        var _a;
        onFilterUpdate(__assign(__assign({}, filter), { modifiers: ((_a = filter.modifiers) === null || _a === void 0 ? void 0 : _a.map(function (m) {
                return __assign(__assign({}, m), { selected: m.type === KpkFilterModifierType.ContainsOne });
            })) || null, values: [
                {
                    id: value,
                    label: value || "",
                    selected: null
                },
            ] }));
    }
    function handleBlur(_event) {
        handleUpdate();
    }
    function handleKeyPress(event) {
        if (event.key === "Enter") {
            handleUpdate();
        }
    }
    return (React__default.createElement(StyledFilterText, { className: clsx("FilterText", className), filter: filter, expanded: expanded, setExpanded: setExpanded, expandIcon: expandIcon, id: id, sx: sx },
        React__default.createElement(TextField, { id: filter.id, label: filter.label, value: value, onChange: function (_a) {
                var target = _a.target;
                return setValue(target.value);
            }, fullWidth: true, onBlur: handleBlur, className: classes.textfield, autoComplete: "off", onKeyPress: handleKeyPress, variant: "outlined", size: "small" })));
};

export { FilterText as default };
//# sourceMappingURL=index.js.map
